/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReservedBloodProductsAliases {
  BLOOD_BAG_MAPPER = 'blood-bag-mapper',
  BLOOD_BAG_TEXT = 'blood-bag-text',
  CONTEXTUAL_BAR = 'contextual-bar',
  DERIVATIVE_DESCRIPTION_MAPPER = 'derivative-description-mapper',
  DERIVATIVE_DESCRIPTION_TEXT = 'derivative-description-text',
  DESCRIPTION_ZONE = 'description-zone',
  RESERVED_BLOOD_PRODUCTS_CARD_CONTAINER = 'reserved-blood-products-card-container',
  RESERVED_BLOOD_PRODUCTS_CARD_CONTAINER_HEADER = 'reserved-blood-products-card-container-header',
  RESERVED_BLOOD_PRODUCTS_DECK = 'reserved-blood-products-deck',
  RESERVED_BLOOD_PRODUCTS_LAYOUT = 'reserved-blood-products-layout',
  RESERVED_BLOOD_PRODUCTS_MAPPER = 'reserved-blood-products-mapper',
  RESERVED_BLOOD_PRODUCTS_PANEL = 'reserved-blood-products-panel',
  STATUS_ICON_PANEL = 'status-icon-panel',
  STATUS_MAPPER = 'status-mapper',
  STATUS_VALUE_ICON_SWITCHER = 'status-value-icon-switcher',
  STATUS_ZONE = 'status-zone',
}
export { ReservedBloodProductsAliases };
